import { PasswordRecoveryPage } from "./PasswordRecoveryPage";
import { strings } from "../lib/strings";

export function ResetPasswordPage(): JSX.Element {
  return (
    <PasswordRecoveryPage
      otpType="recovery"
      title={strings.reset.pageTitle}
      lead={strings.reset.lead}
      successTitle={strings.reset.successTitle}
      successBody={strings.reset.successBody}
      invalidLinkTitle={strings.reset.invalidLinkTitle}
      invalidLinkBody={strings.reset.invalidLinkBody}
    />
  );
}
